import { CircleNotch } from '@phosphor-icons/react'

interface BootScreenProps {
  label?: string
}

/**
 * Full-screen boot screen shown while the app resolves initial auth state.
 * Prevents layout flash (blank page → nav → content) by holding the render
 * until we know who the user is.
 */
export default function BootScreen({ label = 'Loading' }: BootScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg relative overflow-hidden">
      {/* Background texture — same subtle gradient as the main app */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `
            radial-gradient(circle at 10% 0%, rgb(var(--c-primary) / 0.06), transparent 40%),
            radial-gradient(circle at 90% 100%, rgb(var(--c-secondary) / 0.06), transparent 40%)
          `,
        }}
      />

      <div className="relative z-10 text-center select-none">
        {/* Logo / wordmark */}
        <div className="text-6xl font-heading font-black tracking-tighter text-primary-ink anim-flicker mb-3">
          LifeOdds
        </div>

        {/* Loading label with blinking cursor */}
        <div className="flex items-center justify-center gap-2 text-sm text-ink-muted font-mono">
          <CircleNotch className="w-3.5 h-3.5 animate-spin" weight="bold" />
          <span>
            {label}
            <span className="caret" />
          </span>
        </div>
      </div>
    </div>
  )
}
